import React from 'react'

import SectionHeader from '../../common/components/SectionHeader'

import styles from './IncidentDetails.module.css'

const IncidentDetailsSection = ({ title, details }) => {
  const keys = Object.keys(details)

  return (
    <div>
      <SectionHeader title={title} />
      <dl className={styles.sectionInfo}>
        {[].concat.apply(
          [],
          keys.map(key => [
            <dt title={key} key={'dt' + key}>
              {key}
            </dt>,
            <dd key={'dd' + key}>{details[key]}</dd>
          ])
        )}
      </dl>
    </div>
  )
}

export default IncidentDetailsSection
